import dayjs from 'dayjs';
import utc from 'dayjs/plugin/utc';
import type { FormikValues } from 'formik';
import type { Feature, Point, Polygon } from 'geojson';

dayjs.extend(utc);

export interface HistoricVesselsFormValues extends FormikValues {
  dateTimeRange: {
    startDate: string | null;
    endDate: string | null;
  };
  searchArea: Feature<Point | Polygon> | null;
}

const getCurrentStartDate = (): string => {
  const currentDate = new Date();
  currentDate.setDate(currentDate.getDate() - 1);
  return currentDate.toISOString();
};

const getCurrentEndDate = (): string => dayjs().toISOString();

export const getDefaultValues = (): HistoricVesselsFormValues => ({
  dateTimeRange: {
    startDate: getCurrentStartDate(),
    endDate: getCurrentEndDate(),
  },
  searchArea: null,
});
